(function() {
  var processing = false;

  function styleTextNode(node) {
    var text = node.nodeValue;
    if (!text || !text.trim()) return;
    var words = text.split(/(\s+)/);
    var hasLower = words.some(function(w) {
      return w.trim() && w === w.toLowerCase() && /[a-z]/.test(w);
    });
    if (!hasLower) return;

    var frag = document.createDocumentFragment();
    words.forEach(function(w) {
      if (w.trim() && w === w.toLowerCase() && /[a-z]/.test(w)) {
        var em = document.createElement('em');
        em.style.fontStyle = 'italic';
        em.style.textTransform = 'none';
        em.dataset.jbItalic = '1';
        em.textContent = w;
        frag.appendChild(em);
      } else {
        frag.appendChild(document.createTextNode(w));
      }
    });
    node.parentNode.replaceChild(frag, node);
  }

  function processButtons() {
    if (processing) return;
    processing = true;
    try {
      document.querySelectorAll('.btn-primary, .btn-secondary').forEach(function(btn) {
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, {
          acceptNode: function(n) {
            // Skip text already inside our <em> wrappers
            if (n.parentNode && n.parentNode.dataset && n.parentNode.dataset.jbItalic) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        });
        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(styleTextNode);
      });
    } finally {
      processing = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processButtons);
  } else {
    processButtons();
  }

  new MutationObserver(function() { processButtons(); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
